<template>
  <b-navbar
    toggleable
    toggle-breakpoint="xl"
    fixed="top"
    type="dark"
    @click.native="onMenuClick"
  >


    <b-navbar-brand to="/">
      <img src="../assets/logo.png" width="150" alt="">
      <br>
      <a @click="call" href="tel:+78129161500" class="tel">+7 (812) 916-15-00</a>
    </b-navbar-brand>
    <b-nav-toggle
      target="nav_collapse"
      ref="navToggler"

    />
    <b-collapse is-nav id="nav_collapse" ref="collapseNav">

      <b-nav is-nav-bar class="ml-auto">
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'CoursesEntry'}">Начальный уровень</router-link>
        </li>
        <!--
		<li class="nav-item">
          <router-link class="nav-link" :to="{name: 'CoursesAdvanced'}">Продвинутый уровень</router-link>
        </li>
		-->
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'OnlineEnrollment'}">Запись&nbsp;on-line</router-link>
        </li>
        <b-nav-item-dropdown text="Подробнее" right>
            <router-link class="nav-link" :to="{name: 'AboutCourses'}">О&nbsp;курсах</router-link>
            <router-link class="nav-link" :to="{name: 'AboutLectors'}">О&nbsp;лекторах</router-link>
            <router-link class="nav-link" :to="{name: 'Contacts'}">Контакты</router-link>
        </b-nav-item-dropdown>
        <li class="vertical-delimiter" v-if="isDevMode"></li>
        <transition name="slide-fade">
          <li class="auth-btn nav-item" v-if="isDevMode && !isAuth" @click.capture="clicked">
            <router-link class="nav-link" :class="{'disabled wait': !this.$store.state.auth.userChecked }" to="/login" exact>
              Войти
            </router-link>
          </li>
          <b-nav-item-dropdown class="auth-btn" v-if="isAuth" text="Профиль" right>
              <router-link class="nav-link" :to="{name: 'Profile'}">Личный&nbsp;кабинет</router-link>
              <a class="nav-link" href="#" @click.prevent="logout()" :class="{'disabled wait': inProgress }">Выход</a>
          </b-nav-item-dropdown>
        </transition>
      </b-nav>
    </b-collapse>


  </b-navbar>
</template>

<script>
export default {
  name: 'navbar',
  data () {
    return {
      inProgress: false,
      isDevMode: process.env.NODE_ENV === 'development'
    }
  },
  computed: {
    isAuth () {
      return this.$store.getters.isAuth
    }
  },
  methods: {
    call (e) {
      window.location.href = e.target.href
    },
    // в мобильной версии при клике на пункте меню - сворачиваем меню
    onMenuClick (e) {
      const isExpanded = this.$refs.navToggler.$el.attributes['aria-expanded'].nodeValue === 'true'
      if (isExpanded && (e.target.localName === 'a' || e.target.localName === 'img')) {
        this.$refs.collapseNav.toggle()
      }
    },
    clicked (e) {
      if (e.target.className.indexOf('disabled') !== -1) {
        e.preventDefault()
      }
    },
    logout () {
      const token = localStorage.getItem('token')
      if (token && !this.inProgress) {
        this.inProgress = true
        this.$http.post('auth/logout', {}, { headers: { Authorization: token } })
          .then(
            success => {
              this.$store.dispatch('logout')
              this.$router.push({name: 'Home'})
              this.inProgress = false
            },
            error => {
              console.log(error)
              this.inProgress = false
            }
          )
      }
    }
  }
}

</script>

<style>
  .auth-btn {
    min-width: 122px;
    text-align: center;
  }
  .tel, .tel:hover {
    color: white;
    text-decoration: none;
  }
  .navbar-brand br {
    display: none;
  }
  .navbar-brand img {
    margin-right: 15px;
  }
  nav .dropdown .dropdown-menu {
    top: 119%;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 0;
    border: none;
  }
  .dropdown-item.active:hover {
    background-color: none;
  }

  .dropdown .dropdown-menu.show > a.nav-link {
    color: rgba(255, 255, 255, 0.5);
  }
  .dropdown .dropdown-menu.show .nav-link.active {
    color: white;
  }
  .dropdown .dropdown-menu.show .nav-link:hover {
    color: rgba(255, 255, 255, 0.75)
  }
  .dropdown-item.active, .dropdown-item:active {
    background: none;
    border: none;
  }
  .dropdown-item:focus, .dropdown-item:hover {
    background: none;
    border: none;
  }
  .vertical-delimiter {
    border: 1px solid rgba(255, 255, 255, 0.5);
    margin-right: 18px;
  }
  .navbar {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .navbar .nav .auth-btn>a {
    margin-right: 0px;
  }
  nav {
    font-size: 20px;
  }
  .dropdown-menu a {
    font-size: 20px;
  }
  @media(max-height:400px) and (max-width: 1200px) {
    .navbar  {
        position: absolute;
    }
  }
  @media(max-width: 500px) {
    nav .navbar-brand {
      line-height: 0.8;
    }
    .navbar-brand br {
      display: block;
    }
    nav .navbar-brand img {
      width: 100px;
    }
    nav .navbar-brand a {
      font-size: 0.8rem;
    }
    button.navbar-toggler {
      margin-top: 10px;
    }
  }
  /*Before collapse menu*/
  @media(min-width: 1200px) {
    .navbar .nav>li>a {
      margin-right: 20px;
    }
    nav .dropdown .dropdown-menu  {
      text-align: right;
      position: fixed!important;
      left: 0!important;
      right: 0;
      display: block;
      top: 69.5px;
      opacity:0;
      visibility:hidden;
      transition: all 0.2s ease .1s;
    }
    .dropdown.show .dropdown-menu {
      transform: translateY(5px);
      opacity: 1;
      visibility: visible;
    }
    .dropdown-menu a {
      font-size: 19px;
      margin-right: 15px;
      margin-left: 0;
      display: inline-block;
      padding-top: 1px;
    }
  }
  /*After collapse menu*/
  @media(max-width: 1200px) {
    nav li a {
      text-align: right;
    }
    .dropdown-menu a {
      margin-right: 15px;
    }
    .vertical-delimiter {
      display: none;
    }
    .navbar-toggler {
      margin-top: 5px;
    }
    nav .dropdown .dropdown-menu {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
</style>



// WEBPACK FOOTER //
// Navbar.vue?316575b1